import React from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import water_logo from "../../images/water_logo_large.png";

function MessageBanner({ title, description }) {
  return (
    <div className="message-banner">
      <Container fluid="lg">
        <Row>
          <Form.Group as={Col} md="3" className="banner-image">
            <img src={water_logo} className="img-fluid mw-100" alt="Logo" />
          </Form.Group>
          <Form.Group as={Col} className="ps-5 pe-5 mt-4 mb-4">
            <h2>{title}</h2>
            <p className="text-muted">{description}</p>
          </Form.Group>
        </Row>
      </Container>
    </div>
  );
}

export default MessageBanner;
